import { isWriteToolName as isContractTypeWriteTool } from "@/apps/contract-review/components/contract-type-assistant/types";
import { normalizeProposalInput as normalizeContractTypeProposal } from "@/apps/contract-review/components/contract-type-assistant/types";
import { isWriteToolName as isCustomRoleWriteTool } from "@/apps/contract-review/components/custom-role-assistant/types";
import { normalizeProposalInput as normalizeCustomRoleProposal } from "@/apps/contract-review/components/custom-role-assistant/types";

export type SupervisorSpecialistId = "contract-type" | "custom-role";

export type SupervisorSpecialistClient = {
  id: SupervisorSpecialistId;
  label: string;
  apiPrefix: string;
  autoContinuePrompt: string;
};

export const SUPERVISOR_THREAD_SCOPE = "supervisor";

export const CONTRACT_TYPE_SPECIALIST: SupervisorSpecialistClient = {
  id: "contract-type",
  label: "Contract Types",
  apiPrefix: "/api/contract-type-chat",
  autoContinuePrompt:
    "Invoke create-contract-type (or update-contract-type) now with the exact values from your last proposal so the UI can show approval.",
};

export const CUSTOM_ROLE_SPECIALIST: SupervisorSpecialistClient = {
  id: "custom-role",
  label: "Custom Roles",
  apiPrefix: "/api/custom-role-chat",
  autoContinuePrompt:
    "Invoke create-custom-role (or update-custom-role) now with the exact values from your last proposal so the UI can show approval.",
};

export const SUPERVISOR_SPECIALIST_CLIENTS = [
  CONTRACT_TYPE_SPECIALIST,
  CUSTOM_ROLE_SPECIALIST,
] as const;

export function isSupervisorWriteToolName(toolName: string): boolean {
  return isContractTypeWriteTool(toolName) || isCustomRoleWriteTool(toolName);
}

export function specialistForToolName(toolName: string): SupervisorSpecialistClient | null {
  if (isContractTypeWriteTool(toolName)) return CONTRACT_TYPE_SPECIALIST;
  if (isCustomRoleWriteTool(toolName)) return CUSTOM_ROLE_SPECIALIST;
  return null;
}

export function normalizeSupervisorProposal(raw: unknown): Record<string, unknown> {
  return {
    ...normalizeContractTypeProposal(raw),
    ...normalizeCustomRoleProposal(raw),
  };
}
